import * as React from "react";
import * as CheckboxPrimitive from "@radix-ui/react-checkbox";
import { Check } from "lucide-react";

import { cn } from "src/lib/utils";

const Checkbox = React.forwardRef<
	React.ElementRef<typeof CheckboxPrimitive.Root>,
	React.ComponentPropsWithoutRef<typeof CheckboxPrimitive.Root>
>(({ className, ...props }, ref) => (
	<CheckboxPrimitive.Root
		ref={ref}
		className={cn(
			"tw-peer tw-h-[18px] tw-w-[18px] tw-shrink-0 tw-rounded-[5px] tw-border tw-border-border tw-bg-white tw-transition-colors",
			"focus-visible:tw-outline-none focus-visible:tw-ring-2 focus-visible:tw-ring-teal/30 focus-visible:tw-ring-offset-2",
			"disabled:tw-cursor-not-allowed disabled:tw-opacity-50",
			"data-[state=checked]:tw-border-teal data-[state=checked]:tw-bg-teal data-[state=checked]:tw-text-white",
			className
		)}
		{...props}
	>
		<CheckboxPrimitive.Indicator className={cn("tw-flex tw-items-center tw-justify-center tw-text-current")}>
			<Check className="tw-h-3.5 tw-w-3.5" strokeWidth={3} />
		</CheckboxPrimitive.Indicator>
	</CheckboxPrimitive.Root>
));
Checkbox.displayName = CheckboxPrimitive.Root.displayName;

export { Checkbox };
